<template>
    <div class="accountbank">
        <PageTitle icon="fa fa-clone" main="Registro" sub="Conta Bancária" />
        <b-form
            v-show="mode === 'save' || mode === 'remove' || mode === 'read'"
        >
            <input id="accountbank-id" type="hidden" v-model="entity.id" />
            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group label="Nome:" label-for="accountbank-name">
                        <b-form-input
                            id="accountbank-name"
                            type="text"
                            ref="searchFocus"
                            v-model="entity.name_entity"
                            required
                            size="sm"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            placeholder="Nome do Banco..."
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                v-model="entity.blocked"
                                true-value="1"
                                false-value="0"
                                type="checkbox"
                                id="accountbank-blocked"
                                :readonly="
                                    mode === 'remove' ||
                                        mode === 'read' ||
                                        mode === 'insert'
                                "
                            />
                            <label
                                class="form-check-label"
                                for="accountbank-blocked"
                            >
                                Bloqueado?
                            </label>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="3" sm="12">
                    <b-form-group
                        label="Nº do Banco:"
                        label-for="accountbank-insc_state"
                    >
                        <b-form-input
                            id="accountbank-insc_state"
                            type="text"
                            v-model="entity.insc_state"
                            size="sm"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            placeholder="Nº do Banco"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3" sm="12">
                    <b-form-group
                        label="Agência:"
                        label-for="accountbank-insc_municipal"
                    >
                        <b-form-input
                            id="accountbank-insc_municipal"
                            type="text"
                            v-model="entity.insc_municipal"
                            size="sm"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            placeholder="Agência"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3" sm="12">
                    <b-form-group
                        label="Conta Corrente"
                        label-for="accountbank-cnpj_cpf"
                    >
                        <b-form-input
                            id="accountbank-cnpj_cpf"
                            type="text"
                            v-model="entity.cnpj_cpf"
                            required
                            size="sm"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            placeholder="00000-0..."
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group
                        label="Empresa:"
                        label-for="accountbank-company_id"
                    >
                        <b-form-select
                            id="accountbank-company_id"
                            size="sm"
                            :options="companys"
                            v-model="entity.company_id"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="1" sm="2">
                    <b-form-group label="ID" label-for="entity-id">
                        <b-form-input
                            id="entity-id"
                            type="text"
                            title="ALT+ENTER (PESQUISAR)"
                            v-model="entity.entity_bound_id"
                            @input="setEntity()"
                            @change="setEntity"
                            v-on:keyup.alt.enter="openModalEntity"
                            :readonly="docRead"
                            size="sm"
                            placeholder="Código..."
                        />
                    </b-form-group>
                </b-col>
                <b-link
                    v-b-modal.modalEntity
                    v-if="!docRead"
                    class="fa fa-search mt-4"
                ></b-link>
                <b-col md="6" sm="8">
                    <b-form-group
                        label="Nome/Razão Social:"
                        label-for="entity-name_entity"
                    >
                        <b-form-input
                            id="entity-name_entity"
                            type="text"
                            v-model="entity_search.name_entity"
                            size="sm"
                            :readonly="true"
                            placeholder="Nome..."
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="2">
                    <b-form-group label="CPF/CNPJ:" label-for="entity-cnpj_cpf">
                        <b-form-input
                            id="entity-cnpj_cpf"
                            type="text"
                            v-model="entity_search.cnpj_cpf"
                            size="sm"
                            :readonly="true"
                            placeholder=""
                        />
                    </b-form-group>
                </b-col>
                <b-link
                    v-b-modal.modalRegisterEntity
                    v-if="!docRead"
                    class="fa fa-plus mt-4"
                >
                </b-link>
            </b-row>
        </b-form>

        <hr v-show="mode === 'save'" />
        <b-row>
            <b-col xs="12" class="sub-background">
                <b-button
                    size="sm"
                    variant="light"
                    class="mt-2  mb-2 fa fa-plus"
                    v-show="mode !== 'save' && mode !== 'remove'"
                    @click="alterModo"
                >
                </b-button>
                <b-button
                    size="sm"
                    variant="light"
                    class="mt-2 mb-2 ml-2 fa fa-save"
                    v-if="mode === 'save'"
                    @click="save"
                >
                </b-button>
                <b-button
                    size="sm"
                    variant="light"
                    class="mt-2 mb-2 ml-2 fa fa-trash"
                    v-if="mode === 'remove'"
                    @click="remove"
                >
                </b-button>
                <b-button
                    size="sm"
                    btn-sm
                    variant="light"
                    class="mt-2 mb-2 ml-2 fa fa-ban"
                    v-if="
                        mode === 'remove' || mode === 'save' || mode === 'read'
                    "
                    @click="reset"
                >
                </b-button>
                <b-button
                    size="sm"
                    class="mt-2 mb-2 ml-2 fa"
                    :class="icon"
                    @click="
                        ;[
                            loadAccountBanks(),
                            toggleBusy(),
                            (showTable = !showTable),
                        ]
                    "
                    variant="light"
                >
                </b-button>
            </b-col>
        </b-row>
        <br />
        <div class="col-sm-4">
            <div class="form-group">
                <input
                    type="text"
                    size="sm"
                    icon="search"
                    v-model="search"
                    ref="searchFocus"
                    v-show="mode !== 'save' && mode !== 'remove'"
                    placeholder="Informe a descrição"
                    class="form-control"
                />
            </div>
        </div>
        <transition name="slide" type="animation" appear>
            <b-table
                :busy="isBusy"
                class="table-responsive"
                :per-page="perPage"
                :current-page="currentPage"
                v-show="showTable"
                hover
                key="slide"
                head-variant="light"
                :items="filteredList"
                :fields="fields"
            >
                <template v-slot:table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                <template v-slot:cell(actions)="data">
                    <b-button
                        size="sm"
                        variant="light"
                        @click="loadAccountBank(data.item)"
                        class="mr-2 mt-2"
                    >
                        <i class="fa fa-pencil"></i>
                    </b-button>
                    <b-button
                        size="sm"
                        variant="light"
                        @click="loadAccountBank(data.item, 'remove')"
                        class="mr-2 mt-2"
                    >
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
            </b-table>
        </transition>
        <transition name="slide" type="animation" appear>
            <b-pagination
                v-show="showTable"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                size="sm"
                aria-controls="my-table"
            ></b-pagination>
        </transition>

        <b-modal
            id="modalEntity"
            ref="modal"
            title-tag="h6"
            size="lg"
            title="Consulta de Cliente/Fornecedor"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="setSearchEntity"
        >
            <EntitySearchModal
                @setEntityId="entity_id = $event"
                @setEntityName="entity_search.name_entity = $event"
                @setEntityCnpjCpf="entity_search.cnpj_cpf = $event"
            />
        </b-modal>
        <b-modal
            id="modalRegisterEntity"
            hide-footer
            ref="modal"
            size="xl"
            title-tag="h6"
            title="Registro de Cliente/Fornecedor"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
        >
            <EntityModal />
        </b-modal>
    </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
import EntityModal from '../util/EntityModal'
import EntitySearchModal from '../util/EntitySearchModal'
export default {
    name: 'AccountBank',
    components: { PageTitle, EntityModal, EntitySearchModal },
    data: function() {
        return {
            mode: 'insert',
            search: '',
            entity: {},
            entity_search: {},
            entity_id: null,
            entitys: [],
            companys: [],
            showTable: false,
            isBusy: false,
            perPage: 5,
            currentPage: 1,
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            footerBgVariant: 'warning',
            footerTextVariant: 'dark',
            fields: [
                { key: 'name_entity', label: 'Nome', sortable: true },
                { key: 'insc_state', label: 'Nº Banco', sortable: false },
                { key: 'insc_municipal', label: 'Agência', sortable: false },
                { key: 'cnpj_cpf', label: 'Conta Corrente', sortable: false },
                {
                    key: 'blocked',
                    label: 'Bloqueado',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não'),
                },
                { key: 'actions', label: 'Ações' },
            ],
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        filteredList() {
            return this.entitys.filter(entity => {
                return entity.name_entity
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
            })
        },
        icon() {
            return this.showTable ? 'fa-retweet' : 'fa-search'
        },
        rows() {
            return this.loadAccountBanks.length
        },
    },
    methods: {
        loadAccountBanks() {
            const url = `${baseApiUrl}/entitystypeentitys/3`
            axios.get(url).then(res => {
                this.entitys = res.data
            })
        },
        reset() {
            this.mode = 'insert'
            this.loadAccountBanks()
        },
        toggleBusy() {
            this.isBusy = !this.isBusy
        },
        alterModo() {
            this.mode = 'save'
            this.entity = {}
            this.$refs.searchFocus.focus()
        },
        async save() {
            this.entity.type_entity_id = 3
            this.entity.user_id = this.user.id
            const method = this.entity.id ? 'put' : 'post'
            const id = this.entity.id ? `/${this.entity.id}` : ''
            await axios[method](`${baseApiUrl}/entitys${id}`, this.entity)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        async remove() {
            const id = this.accountCash.id
            await axios
                .delete(`${baseApiUrl}/accountCashs/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        loadAccountBank(entity, mode = 'save') {
            this.mode = mode
            this.entity_search = {}
            this.entity = { ...entity }
            this.setEntity()
            this.$refs.searchFocus.focus()
        },
        openModalEntity() {
            this.$bvModal.show('modalEntity')
        },
        async setEntity(entity) {
            if (!this.entity.entity_bound_id) {
                this.entity.entity_bound_id = entity.id
            }

            const url = `${baseApiUrl}/entitys/${this.entity.entity_bound_id}`
            await axios(url).then(res => (this.entity_search = res.data))
        },
        setSearchEntity() {
            this.entity = { ...this.entity, entity_bound_id: this.entity_id }
        },
        async loadCompanys() {
            const url = `${baseApiUrl}/companys`
            await axios.get(url).then(res => {
                this.companys = res.data.map(company => {
                    return { value: company.id, text: company.name_company }
                })
            })
        },
    },
    mounted() {
        this.loadCompanys()
        this.loadAccountBanks()
        this.showTable = true
    },
}
</script>

<style>
.sub-background {
    background: linear-gradient(to top, #bdc3c7, #e7ebee);
    border-radius: 35px;
}

.accountbank label {
    font-size: 0.7rem;
}

.accountbank select {
    font-size: 0.7rem;
}
.accountbank input {
    font-size: 0.7rem;
}
.accountbank button {
    font-size: 0.7rem;
}

#modalRegisterEntity button {
    font-size: 0.7rem;
}

@keyframes slide-in {
    from {
        transform: translateY(40px);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes slide-out {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(40px);
    }
}

.slide-enter-active {
    animation: slide-in 1s ease;
    transition: opacity 1s;
}

.slide-leave-active {
    animation: slide-out 1s ease;
    transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
</style>
